<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save" >
        <v-row>

                    <v-col cols="12" sm="6">
                        <v-text-field

                                prepend-icon="short_text"
                                name="nombre"
                                v-model="form.nombre"
                                :label="$t('cobrox.manual.labels.nombre')"
                                :placeholder="$t('cobrox.manual.labels.nombre')"
                                :error="hasInputErrors('nombre')"
                                :error-messages="getInputErrors('nombre')"
                                color="secondary"
                                :rules="required"
                        ></v-text-field>
                    </v-col>


                    <v-col cols="12" sm="6">

                      <media-field icon="link"
                                   :label="$t('cobrox.manual.labels.link')"
                                   :placeholder="$t('cobrox.manual.labels.link')"
                                   v-model="form.link"
                                   field-name="link"
                                   :error="hasInputErrors('link')"
                                   :error-messages="getInputErrors('link')"
                      ></media-field>

                    </v-col>

        </v-row>
    </v-form>
</template>

<script>

    import {InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'
    import {MediaField} from '@dracul/media-frontend'

    export default {
        name: "ManualForm",
        mixins: [InputErrorsByProps, RequiredRule    ],
        components: {MediaField},
        props:{
            value: {
                type: Object,
                required: true
            },
        },
        computed: {
           form: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
         watch: {
            form: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            }
        },
        data(){
            return {

            }
        }
    }
</script>

<style scoped>

</style>

